import { z } from "zod";
import { LoginTokenData } from "./token";
import { GroupBaseSchema } from "../generated/Group";

export const loginUserSchema = z.object({
  id: z.string().uuid(),
  group_id: z.string().uuid(),
  name: z.string(),
  authority: z.number(),
  deleted_at: z.number().nullable(),
  updatedAt: z.number(),
  createdAt: z.number(),
  Group: GroupBaseSchema.base,
});

export type LoginUser = z.infer<typeof loginUserSchema>;
export type LocalLoginUser = LoginUser & LoginTokenData;
